module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"WidgetSettingsTypesItem":{"hintCountScenarios":"Использовано в сценариях (раз)","buttonSetup":"Настроить","deletionConfirmationText":"Вы действительно хотите удалить данный виджет?"}},"en_us":{"WidgetSettingsTypesItem":{"hintCountScenarios":"Used in scenarios (times)","buttonSetup":"Setup","deletionConfirmationText":"Do you really want to delete this widget?"}}}')
  delete Component.options._Ctor
}
